import { ColumnDef } from "@tanstack/react-table";
import { Link } from "@heroui/link";
import type { TFunction } from "i18next";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { getAuditColumns } from "@/features/Audit/getAuditColumns";

import { CheckIcon } from "@radix-ui/react-icons";

export type A7OPCVMUnderlyingTS = {
  id: number;
  date: Date;
  a7_opcvm_underlying_id: number;
  sous_jacent_en_defaut: string;
  a7_opcvm_issuer_id?: number;
  a7_opcvm_issuer_name?: string;
};

const tableName = "a7_opcvm_underlying_ts";

export const getUnderlyingsTsColumns = (
  t: TFunction,
): ColumnDef<A7OPCVMUnderlyingTS>[] => {
  const tTable = (key: string, defaultValue: string) =>
    t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });
  const tCommon = (key: string, defaultValue: string) =>
    t(`actions.${key}`, { ns: "common", defaultValue });

  return [
    {
      accessorKey: "id",
      header: tTable("id", "ID"),
    },
    {
      accessorKey: "date",
      header: tTable("date", "Date"),
    },
    {
      accessorKey: "a7_opcvm_underlying_id",
      header: tTable("a7_opcvm_underlying_id", "Financial instrument"),
    },
    {
      accessorKey: "a7_opcvm_issuer_name",
      header: tTable("a7_opcvm_issuer_name", "Issuer"),
      cell: ({ row }) => {
        return (
          <Link
            href={toWorkspacePath(
              `/admin/a7-opcvm/a7_opcvm_issuers/${row.original.a7_opcvm_issuer_id}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {row.getValue("a7_opcvm_issuer_name")}
          </Link>
        );
      },
    },
    {
      accessorKey: "sous_jacent_en_defaut",
      header: () => (
        <div className="text-center">
          {tTable("sous_jacent_en_defaut", "Default")}
        </div>
      ),
      cell: ({ getValue }) =>
        getValue() == "YES" && (
          <div className="flex justify-center">
            <CheckIcon />
          </div>
        ),
    },
    {
      id: "actions",
      cell: ({ row }) => {
        return (
          <div className="flex justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {tCommon("edit", "Edit")}
            </Link>
          </div>
        );
      },
    },
  ];
};

export const getUnderlyingTsAuditColumns = (t: TFunction) =>
  getAuditColumns<A7OPCVMUnderlyingTS>(getUnderlyingsTsColumns(t)).filter(
    (column) =>
      ("accessorKey" in column
        ? String((column as { accessorKey?: unknown }).accessorKey ?? "")
        : "") !== "a7_opcvm_issuer_name",
  );
